import targetSegment from "../services/customer.target.segment";
import notification from "../services/notification";
import auth from "./auth";
import authWithMerchantUuid from "./auth";
import _ from "lodash";

export default {
    namespaced: true,
    state: {
        loading: false,
        errors: null,
        targetSegments: [],
        maxPage: 1,
        nextPage: 0,
        prevPage: 0,
        currentPage: 1,
        totalPerPage: 1,
        currentFirstItem: 1,
        currentLastItem: 1,
        initialPageCount: 0,
        searchableFields: [],
        defaultSelectedSearchOption: null,
        branches: [],
        newTargetSegment: {},
        notification: null,
        form: {},
        action: null,
        activeTSUuid: null,
        initializing: false
    },
    mutations: {
        loading(state) {
            state.loading = true;
        },
        errors(state, errors) {
            state.errors = errors;
            state.loading = false;
        },
        targetSegments(state, targetSegments) {
            state.targetSegments = targetSegments;
            state.loading = false;
        },
        pagination(state, pagination) {
            state.totalPerPage = pagination.list.length;
            state.maxPage = pagination.max_page;
            state.prevPage = pagination.prev_page;
            state.nextPage = pagination.next_page;
            state.currentPage = state.prevPage + 1;
            state.currentFirstItem =
                state.totalPerPage > 0
                    ? state.initialPageCount *
                            state.prevPage +
                        1
                    : 0;
            state.currentLastItem =
                state.currentFirstItem > 0
                    ? state.currentFirstItem + state.totalPerPage - 1
                    : 0;
        },
        searchableFields(state, fields) {
            state.searchableFields = fields;
            state.defaultSelectedSearchOption = fields[0].value;
        },
        branches(state, branches) {
            state.branches = branches;
        },
        targetSegment(state, targetSegment) {
            state.targetSegment = targetSegment;
            state.initializing = false;
        },
        initializedForm(state, form) {
            state.form = form;
        },
        activeTSUuid(state, uuid) {
            state.activeTSUuid = uuid;
        },
        action(state, action) {
            state.action = action;
        },
        initializing(state) {
            state.initializing = true;
        },
        resetCsvError(state) {
            if (state.errors && state.errors.errors.csv) delete state.errors.errors.csv;
        },
        setInitialPageCount(state, list) {
            state.initialPageCount = list.length;
        },
    },
    getters: {},
    actions: {
        async getTargetSegments({ commit, state }, param) {
            commit("loading");
            try {
                let response = await targetSegment.getTargetSegments(param);
                
                if (param.page === 1) {
                    await commit("setInitialPageCount", response.list);
                }
                
                commit("targetSegments", response.list);

                let merchant_detail = authWithMerchantUuid;
                let list = [];
                let target = 'rush';

                if (merchant_detail.state.planId === 5) {
                    target = 'zrewards';
                } else if (merchant_detail.state.user.merchant_uuid === 'zeal') {
                    target = 'zpoints';
                }

                for (let index = 0; index < response.list.length; index++) {

                    let paramForTargetSegmentCount = {
                        payload: {
                            target_segment_uuid: response.list[index].target_segment_uuid,
                            merchant_uuid: auth.state.user.merchant_uuid,
                            target: target
                        }
                    };

                    let targetSegmentCount = await targetSegment.getTargetSegmentCount(paramForTargetSegmentCount);
                    response.list[index].customer_count = targetSegmentCount.result.count;

                    list.push({
                        name: response.list[index].name,
                        description: response.list[index].description,
                        customer_count: targetSegmentCount.result.count,
                        visibility: response.list[index].visibility,
                        target_segment_uuid: response.list[index].target_segment_uuid
                    });
                }

                commit("targetSegments", list);
                commit("pagination", response);
                state.loading = false;
            } catch (errors) {
                commit("errors", errors);
                state.loading = false;
            }
        },
        async createTargetSegment({ commit, state }, param) {
            commit("loading");
            try {
                let response = await targetSegment.createTargetSegment(param);
                notification.success(response.message);
                state.loading = false;
            } catch (errors) {
                console.log(errors);
                commit("errors", errors);
                state.loading = false;
                notification.warning("Oops, cannot create target segment.");
            }
        },
        async updateTargetSegment({ commit, state }, param) {
            commit("loading");
            notification.info("Updating target segment.");
            try {
                let response = await targetSegment.updateTargetSegment(
                    param,
                    state.activeTSUuid
                );
                notification.success(response.message);
                state.loading = false;
            } catch (errors) {
                commit("errors", errors);
                state.loading = false;
                notification.warning("Oops, cannot update target segment.");
            }
        },
        async getSearchableFields({ commit }) {
            try {
                let response = await targetSegment.getSearchableFields();
                let searchableFields = [];
                _.forEach(response.searchable_fields, function(value, key) {
                    searchableFields.push({ text: value, value: key });
                });
                commit("searchableFields", searchableFields);
            } catch (errors) {
                commit("errors", errors);
            }
        },
        async getBranches({ commit }) {
            try {
                let response = await targetSegment.getBranches();
                commit("branches", response);
            } catch (errors) {
                commit("errors", errors);
            }
        },
        async visibility({ commit, state }, param) {
            commit("loading");
            try {
                let response = await targetSegment.visibility(
                    param.apiFields,
                    param.uuid
                );
                state.targetSegments[param.index].visibility =
                    param.apiFields.visibility;
                state.loading = false;
                notification.success(response.message);
            } catch (errors) {
                commit("errors", errors);
                state.loading = false;
            }
        },
        async delete({ commit, state }, param) {
            commit("loading");
            try {
                let response = await targetSegment.delete(param);
                let index = _.findIndex(state.targetSegments, function(row) {
                    return row.target_segment_uuid === param;
                });
                state.targetSegments.splice(index, 1);
                state.loading = false;
                notification.success(response.message);
            } catch (errors) {
                if (errors.status === 400) {
                    notification.warning(errors.errors.message);
                } else {
                    notification.warning("Oops, cannot create schedule.");
                }
                state.loading = false;
                commit("errors", errors);
            }
        },
        async viewTargetSegment({ commit, state }) {
            commit("loading");
            commit("initializing");
            try {
                let response = await targetSegment.view(state.activeTSUuid);
                commit("targetSegment", response);
                commit("errors", null);
                state.loading = false;
                return response;
            } catch (errors) {
                state.loading = false;
                state.initializing = false;
                commit("errors", errors);
            }
        },
        async initializedForm({ commit }, form) {
            commit("initializedForm", form);
        }
    }
};
